const { NumberFormat } = Intl;
export class CurrencyService {
    format(locale = 'en', currency, amount, options = {}) {
        var _a;
        let formatOptions = {
            style: 'currency',
            currency,
            currencySign: (_a = options.currencySign) !== null && _a !== void 0 ? _a : 'standard',
        };
        if (currency === 'SGD') {
            formatOptions.currencyDisplay = 'code';
        }
        if (options.numberFormatOptions) {
            formatOptions = Object.assign(Object.assign({}, formatOptions), options.numberFormatOptions);
        }
        if (options.stripDecimals) {
            formatOptions.minimumFractionDigits = 0;
            formatOptions.maximumFractionDigits = 0;
        }
        let formatted = NumberFormat(locale, formatOptions).format(amount);
        if (options.stripSymbol) {
            const { symbol } = this.getSymbolDetails(locale, currency);
            // strip symbol
            formatted = formatted.replace(symbol, '');
            // strip trailing and leading whitespaces
            formatted = formatted.trim();
        }
        return formatted;
    }
    getSymbolDetails(locale = 'en', currency) {
        const formatOptions = { style: 'currency', currency };
        if (currency === 'SGD') {
            formatOptions.currencyDisplay = 'code';
        }
        const formatted = NumberFormat(locale, formatOptions).format(0);
        // Remove all decimal and thousands separators
        // https://en.wikipedia.org/wiki/Decimal_separator
        const symbol = formatted
            .replace(/0/g, '') // zeros
            .replace(/\s|'|,|\.|·|˙/g, '') // western arabic
            .replace(/٫|٬/g, '') // eastern arabic
            .replace(/⎖/g, '') // decimal separator key symbol
            .replace(/:/g, ''); // braille
        const symbolPos = formatted.indexOf(symbol);
        // is the symbol at the beginning
        const leading = symbolPos === 0;
        // is there a space between the symbol and the number
        // TODO: SuppEx to fix this test in migration to lerna
        /* istanbul ignore next */
        const beside = leading ? formatted.substr(symbol.length, 1) : formatted.substr(symbolPos - 1, 1);
        const spaced = /\s/g.test(beside);
        return { symbol, spaced, leading };
    }
}
//# sourceMappingURL=CurrencyService.js.map